import $ from 'jquery'

const MENU_WHITE = '-menu-white'
const MENU_OPEN = '-is-menu-open'
let menuState = []
export default class Header {
  constructor() {
    this.elm = document.querySelector('.c-header')
  }

  init() {
    if (this.elm) {
      this.headerTop()
      this.onMenuClick()
      this.onMenuSubClick()
      this.onTopHeaderScroll()
    }
  }

  headerTop() {
    if (document.querySelector('#top')) {
      $(this.elm).addClass(MENU_WHITE)
      this.logoStyle()
    }
  }

  logoStyle() {
    const logo = $(this.elm).find('.c-header__image')
    const logoName = $('.c-header').hasClass(MENU_WHITE) ? 'logo_white.svg' : 'logo_black.svg'
    logo.attr('src', logo.attr('src').replace(/logo.+/g, logoName))
  }

  onMenuClick() {
    $('.js-menu-toggle').on('click', () => {
      $(this.elm).toggleClass(MENU_OPEN)
      menuState.push($(this.elm).hasClass(MENU_WHITE))

      if ($(this.elm).hasClass(MENU_WHITE)) {
        $('.c-header').removeClass(MENU_WHITE)
        this.logoStyle()
      }
      if (!$(this.elm).hasClass(MENU_OPEN)) {
        if (menuState.shift()) {
          $(this.elm).addClass(MENU_WHITE)
          this.logoStyle()
          menuState = []
        }
      }
    })
  }

  onMenuSubClick() {
    $('.js-link-top-scroll').on('click', () => {
      $('.c-header').removeClass(MENU_OPEN)
    })
  }

  onTopHeaderScroll() {
    if (document.querySelector('#top')) {
      $(window).on('scroll', () => {
        const headerHeight = $('.c-header').innerHeight()

        if (
          $(document).scrollTop() >= $('#news').offset().top - headerHeight / 2 &&
          $(document).scrollTop() < $('#cases').offset().top - headerHeight / 2
        ) {
          $(this.elm).removeClass(MENU_WHITE)
          this.logoStyle()
        } else if (
          $(document).scrollTop() >= $('#cases').offset().top - headerHeight / 2 &&
          $(document).scrollTop() < $('#contact-us').offset().top - headerHeight / 2
        ) {
          $(this.elm).addClass(MENU_WHITE)
          this.logoStyle()
        } else if ($(document).scrollTop() >= $('#contact-us').offset().top - headerHeight / 2) {
          $(this.elm).removeClass(MENU_WHITE)
          this.logoStyle()
        } else {
          this.headerTop()
        }
      })
    }
  }
}
